export enum SoTypesEnum { 
    DISPATCH = 'Dispatch',
    STOCK = 'Stock',
}